function clone(value) {
  return JSON.parse(JSON.stringify(value ?? []))
}

const DEFAULT_GOODS_PATH = '/pages/goods-details/goods-details'
const COMMERCE_DEFAULT_KEYS = ['shopAppId', 'wxAppId', 'goodsPath']

function normalizeCommerceDefaults(defaults) {
  const source = defaults && typeof defaults === 'object' ? defaults : {}
  return COMMERCE_DEFAULT_KEYS.reduce((result, key) => {
    if (Object.prototype.hasOwnProperty.call(source, key)) result[key] = String(source[key] ?? '')
    return result
  }, {})
}

export function runtimeFieldVisibility(agentType, runtimeEngine) {
  const internal = Number(agentType) === 1
  return {
    showRuntime: internal,
    showCapabilities: internal && runtimeEngine === 'mastra',
    showLegacyTools: internal && runtimeEngine === 'legacy',
  }
}

export function capabilityNeedsOptions(capabilityId) {
  return capabilityId === 'commerce.product.search' || capabilityId === 'knowledge.dify.search'
}

export function toggleCapabilityBinding(bindings, capability) {
  const list = clone(Array.isArray(bindings) ? bindings : [])
  const capabilityId = String(capability?.capabilityId || '')
  const index = list.findIndex(item => item.capabilityId === capabilityId)
  if (index >= 0) {
    list.splice(index, 1)
    return list
  }
  if (!capabilityId) return list
  list.push({
    capabilityId,
    version: String(capability.version || 'v1'),
    config: capabilityId === 'commerce.product.search'
      ? {
          storeGuid: '',
          shopAppId: '',
          wxAppId: '',
          goodsPath: DEFAULT_GOODS_PATH,
          tuanzhangId: '',
        }
      : capabilityId === 'knowledge.dify.search' ? { knowledgeBaseIds: [] } : {},
  })
  return list
}

export function setCapabilityConfigValue(bindings, capabilityId, key, value) {
  const list = clone(Array.isArray(bindings) ? bindings : [])
  const binding = list.find(item => item.capabilityId === capabilityId)
  if (!binding || !key) return list
  binding.config = {
    ...(binding.config || {}),
    [key]: Array.isArray(value) ? value.map(item => String(item)) : String(value ?? ''),
  }
  return list
}

export function setCapabilityOptions(bindings, capabilityId, value, defaults = null) {
  const list = clone(Array.isArray(bindings) ? bindings : [])
  const binding = list.find(item => item.capabilityId === capabilityId)
  if (!binding) return list
  if (capabilityId === 'commerce.product.search') {
    binding.config = {
      ...(binding.config || {}),
      storeGuid: String(value || ''),
      ...normalizeCommerceDefaults(defaults),
    }
  } else if (capabilityId === 'knowledge.dify.search') {
    const values = Array.isArray(value) ? value : []
    binding.config = {
      ...(binding.config || {}),
      knowledgeBaseIds: [...new Set(values.map(item => String(item)).filter(Boolean))],
    }
  }
  return list
}

export function hydrateCapabilityDefaults(bindings, capabilityId, options) {
  const list = clone(Array.isArray(bindings) ? bindings : [])
  if (capabilityId !== 'commerce.product.search') return list
  const binding = list.find(item => item.capabilityId === capabilityId)
  if (!binding) return list
  const storeGuid = String(binding.config?.storeGuid || '')
  const option = (Array.isArray(options) ? options : []).find(item => String(item?.value || '') === storeGuid)
  if (!option) return list
  const defaults = normalizeCommerceDefaults(option.defaults)
  const config = { ...(binding.config || {}) }
  for (const key of COMMERCE_DEFAULT_KEYS) {
    if (!String(config[key] || '').trim() && Object.prototype.hasOwnProperty.call(defaults, key)) {
      config[key] = defaults[key]
    }
  }
  binding.config = config
  return list
}

export function validateCapabilityBindings(bindings) {
  for (const binding of (Array.isArray(bindings) ? bindings : [])) {
    if (binding.capabilityId === 'commerce.product.search' && !binding.config?.storeGuid) {
      return '请完成已选 AI 工具的业务范围配置'
    }
    if (binding.capabilityId === 'commerce.product.search') {
      if (!String(binding.config?.shopAppId || '').trim()) return '请填写商城 ID'
      if (!String(binding.config?.wxAppId || '').trim()) return '请填写跳转微信商城 AppID'
      const goodsPath = String(binding.config?.goodsPath || '').trim()
      if (!goodsPath || !goodsPath.startsWith('/') || goodsPath.startsWith('//') || goodsPath.includes('://')) {
        return '请填写有效的商城商品详情小程序路径'
      }
    }
    if (binding.capabilityId === 'knowledge.dify.search' && !(binding.config?.knowledgeBaseIds || []).length) {
      return '请完成已选 AI 工具的业务范围配置'
    }
  }
  return ''
}

export function runtimeSubmitFields(form) {
  const runtimeEngine = form?.runtimeEngine === 'mastra' ? 'mastra' : 'legacy'
  const legacy = runtimeEngine === 'legacy'
  return {
    runtimeEngine,
    capabilityBindings: clone(Array.isArray(form?.capabilityBindings) ? form.capabilityBindings : []),
    mcpServerGuid: legacy ? String(form?.mcpServerGuid || '') : '',
    customToolDefinitions: legacy ? clone(form?.customToolDefinitions || []) : [],
    mcpConfigParam: legacy ? clone(form?.mcpConfigParam || []) : [],
    aiModelGuid: String(form?.aiModelGuid || ''),
  }
}
